// extracted by mini-css-extract-plugin
export default {"page":"TimelinePage_page__yPuqm","social":"TimelinePage_social__8NRUN"};